<div class="main">
    <div class="side-menu" [ngClass]="{'menuClose': !isMenuOpen}">
        <antim-autoware-demo-side-nav [isMenuOpen]="isMenuOpen" (menuToggle)="menuToggle($event)"></antim-autoware-demo-side-nav>
    </div>
    <div class="content">
        <antim-autoware-top-nav [isMenuOpen]="isMenuOpen" (menuToggle)="menuToggle($event)"></antim-autoware-top-nav>
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div (click)="menuToggle(false)" [ngClass]="{'drawer-overlay': isMenuOpen}"></div>